import React from "react";
import Paper from "material-ui/Paper";

export default () => (
  <div>
    <Paper className={"paper-container"}>
      <p>
        The standalone program version is available for download here(link to:{" "}
        <a href="/gs_lw_v10.tgz">gs_lw_v10.tgz</a>).<br />
        The archive contains a source code in C, binary program version, and a
        simple script to convert gromacs structure and topology files to pqrs
        format.
      </p>
    </Paper>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/standalone.js